import React, { useState } from 'react'
import { Input } from 'antd'
import { ToggleEntries } from '../../../../../helpers/commonUi'
import {
  useCreateFunction,
  togglePermission,
  addPermission,
} from '../CreateFunctionContext'
import { ReactComponent as PlusIcon } from '../../../../../assets/svg/MarketplaceFunctions/addBtn.svg'
import style from '../styles/create-function.module.css'

interface IGenericToggleEntries {
  title?: string
  field: 'a8func' | 'a8flow' | 'a8config' | 'a8Astro'
}

const A8Func = () => {
  const { state } = useCreateFunction()
  const permissions = state.permissions.a8func
  const [name, setName] = useState('')
  const { dispatch } = useCreateFunction()
  const [error, setError] = useState('')

  const handleAdd = () => {
    // empty
    if(!name.trim()) {
      setError("Please enter function name")
      return
    }

    // duplicates
    const found = permissions.find(permission => permission.name === name)
    if(found) {
      setError("Function already exists")
      return
    }

    dispatch(addPermission({ field: 'a8func', name }))
    setName('')
    scrollToBottom()
  }

  const scrollToBottom = () => {
    // if we perform the scrolling immediately after adding
    // the element, the height will not be increased by that time.
    // Hence, using a setTimeout here to defer our action
    setTimeout(() => {
      const node = document.querySelector('.sidebarPane')
      if (node) {
        node.scrollTop = node.scrollHeight
      }
    }, 0)
  }


  return (
    <div className={style.spacingHorizontal}>
      <h4 className={style.title}>A8Func</h4>
      <div className={style.a8funcInputWrapper}>
        <Input
          onKeyDown={e => {
            if(e.keyCode === 13) {
              e.currentTarget.blur()
              handleAdd()
            }
          }}
          style={{ width: '70%' }}
          className={style.createFnInput}
          type="text"
          placeholder="Enter function name"
          value={name}
          onChange={(e) => {
            setError("")
            setName(e.target.value)
          }}
        />
        <div onClick={handleAdd} className={style.plusIconWrapper}>
          <PlusIcon width={28} height={28} />
        </div>
      </div>
      {error && <p className={style.errMsg}>{error}</p>}
      <GenericToggleEntries field="a8func" />
    </div>
  )
}

const GenericToggleEntries: React.FC<IGenericToggleEntries> = (props) => {
  const { title, field } = props
  const { state, dispatch } = useCreateFunction()
  const entries = state.permissions[field]

  const handleToggle = (idx: number) => {
    dispatch(togglePermission({ field, idx }))
  }

  return (
    <ToggleEntries
      title={title}
      entries={entries}
      handleToggle={handleToggle}
    />
  )
}

export const Permissions = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <GenericToggleEntries field="a8config" title="A8Config" />
      <GenericToggleEntries field="a8flow" title="A8Flow" />
      <GenericToggleEntries field="a8Astro" title="a8Astro" />
      <A8Func />
    </div>
  )
}
